import { render } from "./EeiaAttachments.vue?vue&type=template&id=0a3c3f79&scoped=true"
import script from "./EeiaAttachments.vue?vue&type=script&lang=js"
export * from "./EeiaAttachments.vue?vue&type=script&lang=js"

import "./EeiaAttachments.vue?vue&type=style&index=0&id=0a3c3f79&scoped=true&lang=css"

import exportComponent from "/var/www/html/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3c3f79"]])

export default __exports__